import { clientApi as dataConnectWebClientApi } from '@openclassrooms/data-connect-web/configuration';
import LightClientApi, { type APILanguage } from '@openclassrooms/sdk';
import { ClientApi } from '@openclassrooms/sdk-web';

import getAdminRequestHeaders from '@/modules/admin/services/getAdminRequestHeaders';

import { PROXY_API_ROUTE } from './constants';

export type Client = LightClientApi<APIEndpoints>;

export type APIClientCredentials = {
  id: string;
  secret?: string;
};

let lightRestClient: Client | null = null;

function createSdkClients(language: APILanguage) {
  const newLightClient = new LightClientApi<APIEndpoints>({
    rootUrl: PROXY_API_ROUTE,
    language,
  });

  newLightClient.addRequestInterceptor((requestData) => {
    const adminHeaders = getAdminRequestHeaders(globalThis.window?.location.href ?? '');
    Object.entries(adminHeaders).forEach(([name, value]) =>
      requestData.options.headers.set(name, value)
    );
    // trick the client, the proxy replaces this header server side
    requestData.options.headers.set('Authorization', 'true');
    return requestData;
  }, true);

  const newClienwApi = new ClientApi({
    rootUrl: PROXY_API_ROUTE,
    language,
  });

  newClienwApi.addRequestInterceptor((requestData) => {
    const headers = {
      ...requestData.requestOptions.headers,
      ...getAdminRequestHeaders(globalThis.window?.location.href ?? ''),
      Authorization: 'true',
    };
    return { ...requestData, requestOptions: { ...requestData.requestOptions, headers } };
  }, true);

  return { newClienwApi, newLightClient };
}

export async function initSDK({ language }: { language: APILanguage }): Promise<Client> {
  if (lightRestClient) {
    return lightRestClient;
  }

  const { newLightClient, newClienwApi } = createSdkClients(language);
  lightRestClient = newLightClient;

  dataConnectWebClientApi.setLightOCClient(lightRestClient);
  dataConnectWebClientApi.setOCClient(newClienwApi);

  return lightRestClient;
}
